<div class="pandio_reviews">

<div class="search">
  <input class="search_input" pInputText type="text" placeholder="Search by review and response text..."
    [(ngModel)]="keyword" (keyup)="userSearch()" />

  <button pButton type="button" icon="fa fa-filter" class="search_filter"
    [ngStyle]="chipsArray.length > 0 && { color: SYSTEM_COLORS.$systemGreen }" (click)="op.toggle($event)">
  </button>

  <p-overlayPanel #op>
    <ng-template pTemplate>
      <div class="search-filter">
        <app-table-filter
          [data]="filterData"
          (filterData)="onChipsRefresh($event)"
        ></app-table-filter>
      </div>
    </ng-template>
  </p-overlayPanel>
</div>

<p class="reviews_date" *ngIf="dateFilterDisplayType === 'custom' ? startDate && endDate : dateFilterLabel">
  <ng-container *ngIf="dateFilterDisplayType === 'custom'; else presetDateFilter">
    <b>Reviews from</b> {{ startDate }} to {{ endDate }}
  </ng-container>
  <ng-template #presetDateFilter>{{ dateFilterLabel }}</ng-template>
</p>

<div class="chips-bar" *ngIf="chipsArray.length">
  <p-chip *ngFor="let chipText of chipsArray" [label]="chipText"></p-chip>
</div>

  <div class="table-container">
    <p-table #reviewTbl class="reviews-table" [value]="reviewData" dataKey="_id"
      [globalFilterFields]="['reviewerComment', 'businessName', 'addressLines', 'city', 'state', 'postalCode', 'storeCode', 'replyComment']"
      [(selection)]="selectedReviews" [lazy]="true" [paginator]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} " (onLazyLoad)="lazyLoadLocations($event)"
      [rows]="pageSize" [totalRecords]="totalReviewsCount" [showCurrentPageReport]="true" [columns]="cols"
      [loading]="loading" sortField="reviewCreatedAt" [sortOrder]="-1" [resetPageOnSort]="false"
      [lazyLoadOnInit]="true" [showPageLinks]="false">

      <!-- Table header -->
      <ng-template pTemplate="header">
        <tr>
          <th *ngFor="let col of tableColumnsHeader" pSortableColumn="{{col.enableSorting ? col.sortingLable : null}}">
            <!-- <p-checkbox *ngIf="col.label === 'SELECT'" [(ngModel)]="selectAllReviews" [binary]="true" (onChange)="handleSelectAllReviews($event)"></p-checkbox> -->
            {{col.label}}
            <p-sortIcon *ngIf="col.enableSorting" field="col.fieldName"></p-sortIcon>
          </th>
        </tr>
      </ng-template>

      <!-- Table data -->
      <ng-template pTemplate="body" let-rowData>
        <tr *ngIf="rowData">
          <td class="select">
            <p-checkbox class="review-table" name="reviews" [value]="rowData" [(ngModel)]="selectedReviews"
              (onChange)="onRowSelect($event)"></p-checkbox>
          </td>
          <!--<td class="directory">{{ rowData?.directory }}</td>-->
          <td class="store-code">{{ rowData?.storeCode }}</td>
          <td class="location-name">
            {{ rowData?.businessName }}<br />
            {{ rowData?.addressLines }}<br />
            {{ rowData?.city }}, {{ rowData?.state }} {{ rowData?.postalCode }}
          </td>
          <td class="review review-row">
            <p *ngIf="rowData.reviewUpdatedAt || rowData.reviewUpdatedAt !== null; else dash">
                  On {{ rowData.reviewUpdatedAt | truncteReviewsDate }}
            </p>
            <p
              [pTooltip]="rowData.reviewerComment ? rowData.reviewTooltip : null"
              tooltipPosition="bottom"
              tooltipStyleClass="review-tooltip"
              hideDelay="250"
              *ngIf="rowData.reviewerComment; else dash"
              class="review-response">
              {{ rowData?.reviewerComment | truncate:300 }}
            </p>
          </td>
          <td class="rating">
            <span class="rating-digit">{{ rowData.starRating }} </span>
            <span class="fa fa-star"></span>
          </td>

          <!-- <td class="response response-row">
            <p *ngIf="rowData.replyUpdatedAt || rowData.replyUpdatedAt !== null; else dash">
              On {{
              rowData.replyUpdatedAt._month_ +
              '/' +
              rowData.replyUpdatedAt.day +
              '/' +
              rowData.replyUpdatedAt._year_
              }}
            </p>
            <p
              [pTooltip]="rowData.replyComment ? rowData.replyTooltip : null"
              tooltipPosition="bottom"
              tooltipStyleClass="review-tooltip"
              hideDelay="250"
              *ngIf="rowData.replyComment; else dash"
              class="review-response">
              {{ rowData.replyComment | truncate:300 }}
            </p>
          </td> -->

          <td class="table-actions">
            <ul class="table-actions-list">
              <li *ngIf="rowData.attrs?.url && sessionService.hasPerm('review', 're')" class="edit-reply"
                (click)="openExternalResponseLink(rowData)"><i class="pi pi-comments" [pTooltip]="'Respond'"
                  tooltipPosition="left">
                </i>
              </li>
              <li class="" (click)="copyReviewToClipboard(rowData)"><i
                class="pi pi-copy action_icon" [pTooltip]="'Copy Review content to clipboard'" tooltipPosition="left"></i>
              </li>
              <!-- <li class="delete-reply" (click)="deleteReview(rowData)"><i class="pi pi-trash action_icon"
                  [pTooltip]="'Delete Review'" tooltipPosition="left"></i>
              </li> -->
            </ul>
          </td>

          <ng-template #dash>
            <img src="assets/horizontal_rule.png" width="16px" />
          </ng-template>
        </tr>
      </ng-template>

    </p-table>
  </div>
</div>
